import React from 'react';
import PromptCard from '../PromptCard';

interface CubemateGuideProps {
  onPromptClick: (prompt: string) => void;
}

const CubemateGuide: React.FC<CubemateGuideProps> = ({ onPromptClick }) => {
  const learningPrompts = [
    "Explain how recursion works in Python with a factorial example",
    "What are interfaces in Java and when should I use them?",
    "Show me how pointers work in C with simple examples",
    "Explain the difference between stack and heap memory in C++",
    "How does ownership and borrowing work in Rust?",
    "How do goroutines and channels work in Go?"
  ];

  const practicePrompts = [
    "Generate a Python program that finds prime numbers between 1 and 100",
    "Create a Java method to check if a string is a palindrome",
    "Write a C function to reverse a linked list",
    "Build a C++ program to implement a stack using templates",
    "Create a Rust program that sorts a vector of student grades",
    "Write a Go program that calculates Fibonacci numbers using recursion"
  ];

  const bestPracticesPrompts = [
    "What are Python naming conventions for variables and functions?",
    "Show me how to properly handle exceptions in Java"
  ];

  return (
    <div className="documentation-content">
      <h1>Codemate - AI Coding Assistant</h1>
      <p className="intro-text">
        Codemate helps you learn programming, solve problems, and build projects.
        Click any prompt below to get started!
      </p>

      <div className="section">
        <h2>Coding Concepts</h2>
        <p className="section-desc">Sharpen your coding skills</p>
        {practicePrompts.map((prompt, index) => (
          <PromptCard key={index} prompt={prompt} onClick={onPromptClick} />
        ))}
      </div>

      <div className="section">
        <h2>Learn by Running</h2>
        <p className="section-desc">Understand core concepts with executable examples</p>
        {learningPrompts.map((prompt, index) => (
          <PromptCard key={index} prompt={prompt} onClick={onPromptClick} />
        ))}
      </div>

      <div className="section">
        <h2>Best Practices</h2>
        <p className="section-desc">Write better code</p>
        {bestPracticesPrompts.map((prompt, index) => (
          <PromptCard key={index} prompt={prompt} onClick={onPromptClick} />
        ))}
      </div>

      <div className="tips-section">
        <h3>Tips for Better Results</h3>
        <ul>
          <li>Be specific about what you want to learn</li>
          <li>Mention your programming language (Python, Java, etc.)</li>
          <li>Ask for examples and explanations</li>
          <li>Use "View Dashboard" for visualizations</li>
          <li>Click "Run" after you click "Execute Code" to run instantly</li>
        </ul>
      </div>

      <div className="doc-section" style={{ marginTop: '1.5rem', padding: '1rem', borderRadius: '0.5rem', background: 'var(--card-bg, rgba(99,102,241,0.08))' }}>
        <p style={{ margin: 0, fontSize: '0.9rem' }}>
          Need help? Reach us at <a href="mailto:support@cubemate.ai" style={{ color: '#7c3aed', fontWeight: 600 }}>support@cubemate.ai</a>
        </p>
      </div>
    </div>
  );
};

export default CubemateGuide;
